import { Component, input, signal } from '@angular/core';
import { LinkComponent } from '../../basic/link/link.component';

@Component({
  selector: 'app-info-box',
  standalone: true,
  imports: [LinkComponent],
  templateUrl: './info-box.component.html',
  styleUrl: './info-box.component.scss'
})
export class InfoBoxComponent {
  infoText = input<string>('');


  protected readonly infoBoxVisible = signal(false);

  toggleInfoBox() {
    this.infoBoxVisible.update((visible) => !visible);
  }
}
